import axiosInstanceNew from "lib/axiosinstanceNew";

const Salarytutors = class {
  constructor() {
    this.baseUrl = "salarytutors";
    this.staticSalaryData = [
      {
        id: 1,
        tutorInfo: {
          first_name: "Rajesh",
          last_name: "Kumar",
          username: "rajesh_kumar",
          email: "rajesh.kumar@example.com",
        },
        payment_due_date: "2024-11-15",
        cycle_completion_date: "2024-11-10",
        total_bonus_amount: 500,
        total_deduction_amount: 200,
        total_amount: 10000,
        status: "Active",
      },
      {
        id: 2,
        tutorInfo: {
          first_name: "Priya",
          last_name: "Singh",
          username: "priya_singh",
          email: "priya.singh@example.com",
        },
        payment_due_date: "2024-11-20",
        cycle_completion_date: "2024-11-15",
        total_bonus_amount: 300,
        total_deduction_amount: 100,
        total_amount: 12000,
        status: "Active",
      },
      {
        id: 3,
        tutorInfo: {
          first_name: "Amit",
          last_name: "Verma",
          username: "amit_verma",
          email: "amit.verma@example.com",
        },
        payment_due_date: "2024-11-05",
        cycle_completion_date: "2024-10-30",
        total_bonus_amount: 200,
        total_deduction_amount: 50,
        total_amount: 8000,
        status: "Hold",
      },
    ];
  }
  //async addshortlist(data=[]) {

  //   return (
  //     await (axiosInstanceNew.post(`${this.baseUrl}`,data))
  //  )
  //}

  async getlist(id) {
    return await axiosInstanceNew.get(`salary?class_id=${id}`);
  }

  async getlistbytutorid(id) {
    // Return dummy salary data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: this.staticSalaryData,
          },
        });
      }, 500);
    });
    // return (
    //   await (axiosInstanceNew.get(`salary?tutor_id=${id}`))
    // )
  }
  async Addsalary(data = []) {
    return await axiosInstanceNew.post(`salary`, data);
  }
};
export default new Salarytutors();
